import { ConditionName, IStarsProps } from "interfaces";
import { conditions } from "helpers";
import dynamic from "next/dynamic";

const StarSlashIcon = dynamic(() => import("../../icon-components/starSlashIcon"));
const StarIcon = dynamic(() => import("../../icon-components/starIcon"));

const Stars = ({ userRating, setUserRating, setButtonActive, starsLabels }: IStarsProps) => {

    const handleUserRating = (userRateSelected: number) => {
        setUserRating(userRateSelected);
        if (userRateSelected !== 1) setButtonActive("positive");
    }

    let stars = <></>;

    if (conditions(ConditionName.isComplexDesktop) && !userRating) {
        stars = (
            <>
                {starsLabels.map((item: string, index: number) => (
                    <div key={item} className={`pl-relative pl-cursor-pointer pl-w-full`} onClick={() => handleUserRating(index + 1)}>
                        <div className="pl-bg-secondary-100 dark:pl-bg-dark-2 pl-border pl-border-secondary-200 dark:pl-border-secondary-400 pl-rounded-[8px] pl-mb-[10px] pl-px-6 pl-py-3"><StarIcon className={`pl-w-full pl-h-full pl-stroke-z-secondary-500 dark:pl-stroke-z-gray-400`} /></div>
                        <p className={`pl-text-[13px] pl-font-normal pl-text-center pl-w-full pl-text-z-secondary-500 dark:pl-text-z-gray-400 ${index + 1 === 5 && "-pl-right-2"}`}>{item}</p>
                    </div>
                ))}
            </>
        )
    } else {
        stars = (
            <>
                {starsLabels.map((item: string, index: number) => (
                    <div key={item} className={`pl-relative pl-cursor-pointer pl-w-[37.1px]`}>
                        {index + 1 <= userRating ? <StarSlashIcon className="pl-w-[37.1px] pl-h-[37.1px]" onClick={() => handleUserRating(index + 1)} /> : <StarIcon className={`pl-w-8 pl-h-8 pl-stroke-z-secondary-500 dark:pl-stroke-z-gray-400`} onClick={() => handleUserRating(index + 1)} />}
                        {conditions(ConditionName.isComplexPortrait) && !userRating && (index + 1 === 1 || index + 1 === 5) && (
                            <p className={`pl-text-[13px] pl-font-normal pl-text-center pl-absolute pl-top-[115%] pl-w-max pl-text-z-secondary-500 dark:pl-text-z-gray-400 ${index + 1 === 5 && "-pl-right-2"}`}>{item}</p>
                        )}
                    </div>
                ))}
            </>
        )
    }


    return <>{stars}</>
}

export default Stars;